// extracted by mini-css-extract-plugin
module.exports = {"faq":"SectionFaq_faq__7R1Sq","container":"SectionFaq_container__OfGvH","faq__title":"SectionFaq_faq__title__fCkFA","faq__list-container":"SectionFaq_faq__list-container__oEBdk"};